import React, { useEffect, useState, useRef } from 'react';
import FunFact from '../../components/FunFactElements/FunFact';
import { useFunFactsData } from '../../data/FunFactsDataContext';

const FunFacts = (props) => {
    const [animated, setAnimated] = useState(false);
    const sectionRef = useRef(null);
    const { funFactsData, isLoading, error } = useFunFactsData();

    useEffect(() => {
        // Modern approach using Intersection Observer instead of jQuery
        const observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry.isIntersecting && !animated) {
                setAnimated(true);
            }
        }, { threshold: 0.1 });

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, [animated]);

    if (isLoading) {
        return (
            <section className={props.className} id="funfacts">
                <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
                    <div className="loading-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading fun facts...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        console.error('Error loading fun facts data:', error);
        // Continue with fallback data (handled by context)
    }

    return (
        <section ref={sectionRef} className={props.className} id="funfacts">
            <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="row w-100">
                    <div className="col-12">
                        <div className="funfacts_inner">
                            {
                                funFactsData.map(data =>
                                    <FunFact
                                        key={data.id}
                                        data={data}
                                    />)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FunFacts;
